import { render, staticRenderFns } from "./GroupDealOverview.vue?vue&type=template&id=78ef6c37"
import script from "./GroupDealOverview.vue?vue&type=script&lang=js"
export * from "./GroupDealOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports